<script>

import Methodology from "../common/Methodology";
import AxesChart from "../data_viz/AxesChart";
import HistoricData from "../data_viz/HistoricData";
import SecondHeader from "../common/SecondHeader";
import BubbleTable from "../data_viz/BubbleTable";
import Resources from "../common/Resources";
import InstTransv from "../data_viz/InstTransv";
import GaugeChart from "../charts/GaugeChart";
import Histogram from "../charts/Histogram";
import { Stack, StackItem } from 'vue-stack-grid';
import homeMixin from "../homeMixin";
import homeHolderMixin from "../homeHolderMixin";
import { mapState, } from "vuex";
import TitleCard from "../common/TitleCard";

export default {
  name: 'HomePage',
  components: {
    Methodology,
    AxesChart,
    HistoricData,
    SecondHeader,
    BubbleTable,
    Resources,
    InstTransv,
    GaugeChart,
    Histogram,
    Stack,
    StackItem,
    TitleCard,
  },
  mixins: [homeMixin, homeHolderMixin],
  data(){
    return {
      transver_value: undefined,
      show_metod: false,
      instit_value: undefined,
      basic_desc: ['El Observatorio Nacional para la Igualdad de Género en las Instituciones de Educación Superior (ONIGIES) nace como una apuesta colectiva a favor de la construcción de espacios de conocimiento libres de sexismo, segregación, violencia, discriminación y cualquier otra forma de desigualdad basada en la condición de género de las personas que integran las comunidades académicas en México.', ' '],
      //show_charts: false,
      //category: {'color':'#4a820c'},
      //        : '#CDDC39' 
      //#4a820c
        //#3e6c0a'
    }
  },
  computed:{
    ...mapState({
      current_period: state => state.current_period,
      valid_periods: state => state.valid_periods,
      page_setup: state => state.page_setup,
    }),
    content(){
      if (!this.page_setup)
        return this.basic_desc
      else
        return this.page_setup.about.split("<hr />")
    },    
  },
  created(){
    var extra = [{
      'state': 'last_values',
      'method':'FETCH_INDICADOR_VALUES',
      'eachPetition': true,
      'send_year': true
    }]
    //console.log("created HomePage")
    this.getHomeCats(extra)
  },
  beforeRouteUpdate (to, from, next) {
    this.setAxisReady(false)
    this.updateAxis(to.params.slug)
    next()
  },
}
</script>

<template>
  <div>
    <second-header
      :periods="valid_periods"
    />
    <v-card class="mt-2 mx-1" tile flat>
      <stack 
        ref="stack"
        :column-min-width="380"
        :gutter-width="8"
        :gutter-height="8"
       
      >
        <stack-item>
          <gauge-chart 
            :value="current_period ? current_period.equality_index : null"
            class="pa-3"
            :period="current_period"
          />
        </stack-item>
        <stack-item>
          <axes-chart class="pa-3"/>
        </stack-item>
        <stack-item>
          <histogram class="align-self-start pa-3"/>
        </stack-item>
        <stack-item>
          <resources :period="current_period" v-if="current_period"/>
        </stack-item>
        <stack-item>
          <historic-data class="pa-3"/>
        </stack-item>
        <stack-item>
          <inst-transv/>
        </stack-item>
      </stack>
    </v-card>
    <v-card class="pa-3 mx-1 mb-3" elevation="5">
      <title-card text="Sobre el ONIGIES"/>
      <div class="pt-2 pb-0 mx-3" v-html="content[0]"/>
      <v-card-actions v-if="!show_metod" class="py-0">
        <v-spacer></v-spacer>
        <v-btn color="accent" text large @click="show_metod = true">
          Leer más
          <v-icon>keyboard_arrow_down</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>

      <v-row class="mx-0 px-3">
        <template v-if="show_metod">
          <span v-html="content[1]"/>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey" text @click="show_metod = false">
              Ocultar Sección
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </template>
      </v-row>
    </v-card>
    <methodology/>
    <bubble-table ref="bubble_table"/>
  </div>
</template>